import { CompletePassPurchaseFragment, Maybe } from 'drycut-graphql';
import { ActionButtons, Button, Heading, MobileNavbar, Para, Stack } from 'ui-components';
import GrayBox from '../GrayBox';
import { useNavigate } from 'react-router';
import { formatDateTime } from 'ui-format-utils';
import { Navigation } from 'navigation';
import { useTimeout } from 'usehooks-ts';

type Props = {
  storeSlug?: string;
  passPurchase?: Maybe<CompletePassPurchaseFragment>;
  manual?: boolean;
};

export function PassDetails({
  storeSlug,
  passPurchase,
  manual = false,
}: Props): React.ReactElement {
  const navigate = useNavigate();

  const pathAfterPurchase = manual ? `/${storeSlug}` : `${Navigation.BOOKING_URL}`;

  useTimeout(() => {
    if (manual) {
      // If it is a manual pass purchase, navigate to the store page after 20 seconds
      navigate(pathAfterPurchase);
    }
  }, 20000);

  return (
    <Stack
      gap={7}
      className="h-full text-center font-aribau gap-9 lg:gap-7"
      id="main-booking-details"
    >
      <MobileNavbar title="Deine Buchung" />

      <Stack>
        <Heading variant="h2" className="hidden lg:block">
          Deine Buchung
        </Heading>
      </Stack>

      <GrayBox>
        <Para size="2xl">Deine Auswahl</Para>

        <Para size="2xl" weight="bold">
          {passPurchase?.pass.title}
        </Para>
      </GrayBox>

      <GrayBox>
        <Para size="2xl">DRYPASS code</Para>

        <Para size="2xl" weight="bold">
          {passPurchase?.coupon?.code}
        </Para>
      </GrayBox>

      <Stack>
        <Para weight="bold" className="text-primary-600">
          Deine Buchungsinformationen:
        </Para>

        <GrayBox gap={1} className="text-xs mt-2 text-zinc-500">
          <p>Name: {passPurchase?.customer.name}</p>
          <p>Datum: {formatDateTime(passPurchase?.createdAt, { dateStyle: 'long' })}</p>
          <p>
            Preis: CHF {passPurchase?.pass.price} (statt {passPurchase?.pass.basePrice} CHF)
          </p>
          <p>Gültig bis: {formatDateTime(passPurchase?.coupon?.expiresAt)}</p>
          <p>Verbleibende Cuts: {passPurchase?.coupon?.usesLeft}</p>
        </GrayBox>
      </Stack>

      <Para className="text-xs text-zinc-500 italic">
        Dieser Code ist in allen unseren Salons einlösbar.
      </Para>

      <ActionButtons>
        <Button as="a" href={pathAfterPurchase} role="link">
          Nächsten Cut buchen
        </Button>
      </ActionButtons>
    </Stack>
  );
}
